import { useAuth0 } from '@auth0/auth0-react';
import { useEffect } from 'react';
import logger from './loggerManager';

export const useGetTokenInterval = () => {
  const { getAccessTokenSilently } = useAuth0();
  const INTERVAL_DURATION = 1000 * 60;

  useEffect(() => {
    const timer = setInterval(async () => {
      try {
        await getAccessTokenSilently();
      } catch (e) {
        logger.error('failed to get access token', {
          function: 'useGetTokenInterval',
          filename: 'tokenManager.ts',
          error: e,
        });
      }
    }, INTERVAL_DURATION);
    return () => clearInterval(timer);
  }, []);
};
